import styled from "styled-components";
import { ChevronDown, ChevronUp, Dash } from "react-bootstrap-icons";

export const StyledSLContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* Bounded to fit within the outer popup (which has 32px/side padding), so
     this container never needs its own scroll - only the location list
     below does. Without this, both the popup and the list would scroll
     independently, which is confusing to navigate. */
  height: calc(90vh - 64px);
  max-height: calc(90vh - 64px);
  overscroll-behavior: none;

  @media (max-width: 600px) {
    height: calc(100lvh - 40px);
    max-height: calc(100lvh - 40px);
  }
`;

export const StyledSLSelectionContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: none;
  border: solid #608cdf 1px;
`;

export const StyledSLText = styled.div`
  margin-bottom:5px;
`;

export const StyledSLUl = styled.ul`
  margin-top: 2px;
  ul,
  li {
    list-style-type: none;
    list-style-position: inside;
    margin-left: 5px;
    padding-left: 5px;
    overflow-y: auto;
  }
  @media (max-width: 600px) {
    padding-left: 2%;
    ul,
    li {
      list-style-type: none;
      list-style-position: inside;
      margin-left: 2px;
    }
  }
`;

export const StyledSLDownArrow = styled(ChevronDown)`
  font-size: 12px;
  margin-right: 3px;
  border-radius: 100%;
  border: none;
`;

export const StyledSLUpArrow = styled(ChevronUp)`
  font-size: 12px;
  margin-right: 3px;
  border-radius: 100%;
  border: none;
`;

export const StyledSLDash = styled(Dash)`
  font-size: 12px;
  margin-right: 3px;
  border-radius: 100%;
  border: none;
`;

export const StyledSLNavy = styled.span`
  color: #000035;
`;

export const StyledSLSelected = styled.span`
  color: #ffcc33;
`;

export const StyledSLBreadcrumb = styled.span`
  color: #ffffff;
  opacity: 0.7;
`;

export const StyledSLSearchWrapper = styled.div`
  display: flex;
  gap: 5px;
  margin-bottom: 5px;
`;

export const StyledSLSearchInput = styled.input`
  flex: 1;
  min-width: 0;
  box-sizing: border-box;
  padding: 8px;
  border: solid #608cdf 1px;
  border-radius: 4px;
  font-size: 14px;

  @media (max-width: 600px) {
    /* iOS Safari auto-zooms the page on focus for any field under 16px */
    font-size: 16px;
  }
`;

export const StyledSLClearSearchButton = styled.button`
  flex-shrink: 0;
  border: solid #608cdf 1px;
  border-radius: 4px;
  background: #fff;
  color: #608cdf;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 12px;

  &:hover {
    background: #608cdf;
    color: #fff;
  }
`;

export const StyledSLNoResults = styled.div`
  padding: 8px;
  color: #666;
  font-style: italic;
`;

export const StyledSLCurrentLocationLabel = styled.div`
  font-size: 14px;
  font-style: italic;
  color: #000035;
  margin-left: 18px;
`;

export const StyledSLSelectedLabel = styled.div`
  font-size: 14px;
  font-style: italic;
  color: #ffcc33;
  margin-left: 18px;
`;
